import Vue from "vue";
import Vuex from "vuex";
import { login, getPermission } from "@/api/user";
import { handlePermissionData } from "@/utils/permission";
import mockData from "./config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    code: undefined,
    // openid: "oBudyxKT9tf0pb-Bs5ZHx7nl_nSY",
    openid: "",
    dateList: [],
    permission: { region: [], shop: [] },
  },
  mutations: {
    setDateList(state, list) {
      state.dateList = list;
    },
    setOpenid(state, openid) {
      state.openid = openid;
    },
    setPermission(state, permission) {
      state.permission = permission;
    },
    setCode(state, code) {
      state.code = code;
    },
  },
  actions: {
    getOpenid({ state, commit }, code) {
      return new Promise((resolve, reject) => {
        // login(code)
        getPermission()
          .then((rows) => {
            console.log(rows);

            // res.rows = mockData;
            if (rows && rows.length > 0) {
              commit("setOpenid", rows[0].open_id);
              console.log(rows);
              let permission = handlePermissionData(rows);
              commit("setPermission", permission);
              resolve(permission);
            } else {
              reject(new Error("err"));
            }
          })
          .catch((err) => {
            reject(new Error(err));
          });
      });
    },
  },
  modules: {},
});
